
import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http";
import { Chart } from "react-google-charts";
import NoData from "../../NoData";
import ChartLoader from "../../ChartLoader";
import CommanBarTable_Orion from "../CommanBarTable_Orion";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";
import WaterMark from "../../DashboardMain_Orion/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function CoolantInVehicles_Orion({
  apiend,
  gloablfilter,
  type,
  chartnameFCD,
  coolantin_Option,
  coolantin_OptionMM,
  finalCoolantKey
}) {
  const [chartdata, setChartData] = useState([]);
  const [apiResponse, setApiResponse] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const { isLoading, sendReq: fetchData } = useHttp();

  const barcolor = "#83A4CF";

  // -------------------------------
  // BIN DEFINITIONS
  // -------------------------------
  const bins = [
    { label: "<25", min: -Infinity, max: 25 },
    { label: "25-50", min: 25, max: 50 },
    { label: "50-75", min: 50, max: 75 },
    { label: "75-100", min: 75, max: 100 },
    { label: "100-125", min: 100, max: 125 },
    { label: "125-150", min: 125, max: 150 },
    { label: ">150", min: 150, max: Infinity }
  ];

  // FIND BIN LABEL FOR VALUE
  const getBinLabel = (value) => {
    const bin = bins.find((b) => value >= b.min && value < b.max);
    return bin ? bin.label : ">150";
  };

  // -------------------------------
  // PROCESS API → APPLY BINS
  // -------------------------------
  const processAPI = (data) => {
    setApiResponse(data);

    if (!data || data.length === 0) {
      setChartData([]);
      return;
    }

    // GOOGLE CHART HEADER
    const rawChartData = [["Coolant Bin", "Vehicle Count", { role: "style" }]];

    // GROUP BY BIN
    const binCounts = {};
    bins.forEach((b) => (binCounts[b.label] = 0));

    data.forEach((item) => {
      const value = item[coolantin_Option]?.value ?? null;
      if (value !== null) {
        const binLabel = getBinLabel(value);
        binCounts[binLabel] += 1;
      }
    });

    // BUILD GOOGLE CHART DATA
    Object.keys(binCounts).forEach((label) => {
      rawChartData.push([
        label,
        binCounts[label],
        "stroke-width:1; stroke-color:black;"
      ]);
    });

    setChartData(rawChartData);
  };

  // -------------------------------
  // CHARTJS – SAME BINS
  // -------------------------------
  const chartJsData = {
    labels: bins.map((b) => b.label),
    datasets: [
      {
        label: "Vehicle Count",
        data: bins.map((b) => {
          let c = 0;
          apiResponse.forEach((item) => {
            const val = item[coolantin_Option]?.value ?? null;
            if (val !== null && val >= b.min && val < b.max) c++;
          });
          return c;
        }),
        backgroundColor: barcolor,
        borderWidth: 1,
        borderColor: "black"
      }
    ]
  };

  const chartJsOptions = {
    responsive: true,
    plugins: { legend: { display: false } },
    scales: {
      x: { title: { display: true, text: "Coolant Bins" } },
      y: { title: { display: true, text: "Vehicle Count" } }
    }
  };

  // GOOGLE CHART OPTIONS
  const googleChartOptions = {
    hAxis: { title: "Coolant Bins" },
    vAxis: { title: "Vehicle Count" },
    legend: "none",
    series: { 0: { color: barcolor } }
  };

  // API CALL
  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "orion_charging_analysis/" + apiend,
        body: {
          filterdata: gloablfilter,
          coolantin_Option,
          coolantin_OptionMM
        }
      },
      processAPI
    );
  }, [gloablfilter, type, coolantin_Option, coolantin_OptionMM]);

  return (
    <>
      {/* ZOOM MODAL */}
      <div className="modal fade" id={apiend + "_zoom"} tabIndex={-1}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{chartnameFCD}</h5>
              <button className="btn-close" data-bs-dismiss="modal" />
            </div>

            <div className="modal-body d-flex justify-content-center" style={{ height: "400px" }}>
              {isLoading ? (
                <ChartLoader />
              ) : chartdata.length > 1 ? (
                <Bar data={chartJsData} options={chartJsOptions} />
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ZOOM ICON */}
      <strong
        data-bs-toggle="modal"
        data-bs-target={"#" + apiend + "_zoom"}
        className="Zoom_first_page d-flex justify-content-end"
        style={{ cursor: "pointer" }}
      >
        <BsZoomIn />
      </strong>

      <WaterMark />

      {/* MAIN GOOGLE CHART */}
      {isLoading ? (
        <ChartLoader />
      ) : chartdata.length > 1 ? (
        <Chart
          chartType="ColumnChart"
          data={chartdata}
          width="100%"
          height="200px"
          options={googleChartOptions}
          chartEvents={[
  {
    eventName: "select",
    callback: ({ chartWrapper }) => {
      const chart = chartWrapper.getChart();
      const sel = chart.getSelection();

      if (sel.length === 1 && sel[0].row != null) {
        const rowIndex = sel[0].row; // index in chartdata, excludes header
        const binLabel = chartdata[rowIndex + 1][0]; // +1 because chartdata[0] is header
        const binObj = bins.find((b) => b.label === binLabel);

        if (binObj) {
          const filtered = apiResponse.filter((item) => {
            const val = item[coolantin_Option]?.value ?? null;
            return val !== null && val >= binObj.min && val < binObj.max;
          });

          setFilteredData(filtered);
          window.$(`#modal_${apiend}`).modal("show");
        }
      }
    }
  }
]}

        />
      ) : (
        <NoData />
      )}

      {/* TABLE MODAL */}
      <div className="modal fade" id={`modal_${apiend}`} tabIndex={-1}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{chartnameFCD}</h5>
              <button className="btn-close" data-bs-dismiss="modal" />
            </div>

            <div className="modal-body">
              <CommanBarTable_Orion data={filteredData} tabDataKey={finalCoolantKey} noFifty="noFifty" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CoolantInVehicles_Orion;
